import React, { FC, memo } from 'react';

import cn from 'classnames';

import styles from './WorkspaceFields.module.scss';

import { ErrorMessage, useField } from 'formik';
import { FormControl, RadioGroup, FormControlLabel, Radio } from '@mui/material';
import { CheckboxIconChecked, CheckboxIconUnchecked } from 'src/atoms/CustomizedCheckbox/adds/CheckboxIcons';

type TCustomRadioGroupProps = {
  name: string;
  options: { label: string; value: string }[];
};

const CustomRadioGroup: FC<TCustomRadioGroupProps> = memo(({ name, options }) => {
  const [field, meta] = useField<string>(name);

  const hasError = Boolean(meta.error);

  return (
    <FormControl error={hasError} className={styles.radioGroupWrapper}>
      <RadioGroup
        row
        name={field.name}
        value={field.value ?? ''}
        onChange={field.onChange}
        onBlur={field.onBlur}
        className={styles.radioGroup}
      >
        {options.map((opt) => (
          <FormControlLabel
            key={opt.value}
            value={opt.value}
            className={styles.formControlLabel}
            control={
              <Radio
                icon={<CheckboxIconUnchecked uncheckedBoxClass={styles.checkboxIcon} />}
                checkedIcon={<CheckboxIconChecked checkedBoxClass={styles.checkboxIcon} />}
              />
            }
            label={opt.label}
          />
        ))}
      </RadioGroup>

      <ErrorMessage
        name={name}
        render={(msg) => <div className={cn(styles.formErrorMessage, styles.errorClass)}>{msg}</div>}
      />
    </FormControl>
  );
});

CustomRadioGroup.displayName = 'CustomRadioGroup';

export default CustomRadioGroup;
